module.exports = __webpack_public_path__ + "img/ville-drummondville.db49e803.png";